import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AppBreadcrumbModule } from '@coreui/angular';
import { TranslateModule } from '@ngx-translate/core';
import { ChartsModule, ThemeService } from 'ng2-charts';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { AppMaterialModule } from '../../../app-material/app-material.module';
import { DatePickerModule } from '../../datePicker/date-picker/date-picker.module';
import { PdfExporterModule } from '../../pdf-exporter/pdf-exporter.module';
import { StatisticsCardModule } from '../statistics-card/statistics-card.module';
import { CustomStatisticsComponent } from './custom-statistics.component';

@NgModule({
  declarations: [CustomStatisticsComponent],
  entryComponents: [CustomStatisticsComponent],
  imports: [
    CommonModule,
    FormsModule,
    AppMaterialModule,
    ChartsModule,
    TranslateModule,
    AppBreadcrumbModule,
    TranslateModule,
    NgxDaterangepickerMd,
    DatePickerModule,
    StatisticsCardModule,
    PdfExporterModule
  ],
  providers: [
    ThemeService
  ],
  exports: [CustomStatisticsComponent]
})
export class CustomStatisticsModule { }
